import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CONST_URL_SEGEMENTS } from '@fitness-force/constants';
import { BadRequestError, AppErrors, NotFoundError } from '@fitness-force/errors';
import { ClientTrialById, CreateClientTrial, ListClientInteraction, ListClientTrial, TrialBookingRequest } from '@fitness-force/models';
import { environment } from 'apps/ff-frontend/src/environments/environment';
import { Observable, map, catchError, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ClientTrialService {

  constructor(private http: HttpClient) { }

  BASE_URL: string = environment.BASE_URL;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    })
  };

  getClientTrials(tenantId: number, clientId:number): Observable<ListClientTrial> {
    const url = this.BASE_URL + CONST_URL_SEGEMENTS.CLIENT_TRIAL.GET_TRIALS.replace('{tenant_id}', tenantId.toString()).replace('{client_id}', clientId.toString());
    return this.http.get(url, {headers: this.httpOptions.headers}).pipe(
      map((res: any) => {
        if (res) {
          return res
        }
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  getClientTrial(tenantId: number, clientId:number, trialId:number): Observable<ClientTrialById> {
    const url = this.BASE_URL + CONST_URL_SEGEMENTS.CLIENT_TRIAL.GET_TRIAL.replace('{tenant_id}', tenantId.toString()).replace('{client_id}', clientId.toString())
    .replace('{clt_trial_id}', trialId.toString());
    return this.http.get(url, {headers: this.httpOptions.headers}).pipe(
      map((res: any) => {
        if (res) {
          return res
        }
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  CreateClientTrial(tenantId:number,clientId:number,createTrialRequest: CreateClientTrial)
  {
   
    const url = this.BASE_URL + CONST_URL_SEGEMENTS.CLIENT_TRIAL.POST_TRIAL.replace('{tenant_id}', tenantId.toString()).replace('{client_id}', clientId.toString());
    return this.http.post<CreateClientTrial>(url,createTrialRequest,{headers: this.httpOptions.headers}).pipe(map((res: any) => {
      if (res) {
        return res;
      }
    }), catchError((error: Response) => {
      if (error.status === 404) {
        return throwError(() => new NotFoundError(error));
      }
      return throwError(() => new AppErrors(error));
    }));
  }

  CreateClientTrialWithClassBooking(tenantId:number,classId: number, bypassLimit:boolean, trialBookingRequest:TrialBookingRequest)
  {
    let headers = new HttpHeaders();
    headers = headers.append('Bypass-Trial-Limit',bypassLimit.toString());
    headers = headers.append('Content-Type', 'application/json');

    const url = this.BASE_URL + CONST_URL_SEGEMENTS.SCHEDULING.CLASS_BOOKING.ADD_TRIAL_TO_CLASS.replace('{tenant_id}', tenantId.toString()).replace('{class_id}', classId.toString());
    return this.http.post<TrialBookingRequest>(url,trialBookingRequest,{headers}).pipe(map((res: any) => {
      if (res) {
        return res;
      }
    }), catchError((error: Response) => {
      if (error.status === 404) {
        return throwError(() => new NotFoundError(error));
      }
      return throwError(() => new AppErrors(error));
    }));
  }

}
